// Considered: CollapsibleSection atom — rejected: no grid identity, settings surface, or emit/accept
// contract (see spec Reuse Audit, specs/space-composition.md § Design System Reuse Audit).
import React from 'react';
import { useTranslation } from 'localization';
import './SectionFrameMolecule.scss';

export interface SectionFrameMoleculeProps {
  componentId: string;
  title?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  /** Org that owns the composition rendered inside this Section, when known. */
  publisherOrgId?: string;
  /** Display name for `publisherOrgId`, shown in the attribution line. */
  publisherOrgName?: string;
  /** The viewing identity's org. A line renders only when this differs from `publisherOrgId` (OQ5 mitigation). */
  viewerOrgId?: string;
}

const SectionFrameMolecule: React.FC<SectionFrameMoleculeProps> = ({
  componentId,
  title,
  children,
  className,
  publisherOrgId,
  publisherOrgName,
  viewerOrgId,
}) => {
  const { t } = useTranslation();
  const classes = ['section-frame-molecule', className].filter(Boolean).join(' ');
  const showPublisherAttribution = Boolean(publisherOrgId && viewerOrgId && publisherOrgId !== viewerOrgId);

  return (
    <div className={classes} data-component-id={componentId} role="region" aria-label={typeof title === 'string' ? title : undefined}>
      {title && <div className="section-frame-molecule__title">{title}</div>}
      {showPublisherAttribution && (
        <div className="section-frame-molecule__publisher-attribution">
          {t('space.section.publisherAttribution', { publisherName: publisherOrgName ?? publisherOrgId })}
        </div>
      )}
      <div className="section-frame-molecule__body">{children}</div>
    </div>
  );
};

SectionFrameMolecule.displayName = 'SectionFrameMolecule';

export default SectionFrameMolecule;
